module.exports = __webpack_public_path__ + "img/mft_gold_black.80533a7a.png";